/* eslint-disable no-param-reassign */

const formatOrderItem = (item) => {
  const {
    category_name: categoryName,
    id,
    name,
    quantity,
    unit_price: unitPrice,
    total_unit_price: totalUnitPrice,
    total_price: totalPrice,
    refund_reason: refundReason,
    modifiers,
  } = item;

  return {
    categoryName,
    id,
    name,
    quantity,
    refundReason,
    unitPrice: unitPrice && {
      formatted: unitPrice.formatted,
    },
    totalUnitPrice: totalUnitPrice && {
      formatted: totalUnitPrice.formatted,
    },
    totalPrice: totalPrice && {
      formatted: totalPrice.formatted,
    },
    modifiers: modifiers.map((modifier) => ({ name: modifier.name })),
  };
};

const formatCompensation = (payload) => {
  const {
    id,
    status,
    refund_status: refundStatus,
    refund_date: refundDate,
    action_id: action,
    input_description: inputDescription,
    photos,
    compensated_items: compensatedItems,
    selected_resolution: {
      resolution_type: resolutionType,
      source,
      repeat_order_id: repeatOrderId,
      amount,
    },
  } = payload;
  if (amount !== null) {
    amount.currency_code = amount.currencyCode;
  }
  return {
    id,
    status,
    refundStatus,
    refundDate,
    action,
    inputDescription,
    photos,
    compensatedItems,
    selectedResolution: {
      resolutionType,
      source,
      repeatOrderId,
      amount,
    },
  };
};

const formatOrder = (payload) => ({
  // the id key differs between 'list' and 'detail' payloads
  id: payload.order_id || payload.id,
  uuid: payload.order_uuid,

  branchId: payload.branch_id,
  status: payload.status,
  rejectionReason: payload.rejection_reason,
  amountFormatted: payload.amount && payload.amount.formatted,
  orderNumber: payload.order_number,
  placedAt: payload.timeline && payload.timeline.placed_at,

  customerId: payload.customer && payload.customer.id,

  // only deep/detailed order payloads have `items`
  items: payload.items && payload.items.map(formatOrderItem),
  totalItems: payload.items && payload.items.length,

  refundStatus: payload.order_refund_status,
  refundTotal: payload.refund_total,
  orderType: payload.order_type,
  compensationIssues:
    payload.compensations && payload.compensations.map(formatCompensation),
});

const formatSummary = (payload) => {
  const {
    total_orders: totalOrders,
    accepted_orders: acceptedOrders,
    gross_revenue: grossRevenue,
    average_order_value: averageOrderValue,
  } = payload;

  if (!totalOrders) return undefined;

  return {
    totalOrders,
    acceptedOrders,
    grossRevenue,
    averageOrderValue,
  };
};

const formatOrders = (payload) => {
  const { orders = [] } = payload;

  const ordersById = orders.reduce((result, order) => {
    const formatted = formatOrder(order);
    result[formatted.id] = formatted;
    return result;
  }, {});

  return {
    ordersById,
    orders: orders.map(formatOrder),
  };
};

const formatBranchId = (payload) => payload.restaurant_id;

export default {
  order: formatOrder,
  orders: formatOrders,
  summary: formatSummary,
  branchId: formatBranchId,
};
